import { useStore } from 'src/contexts/StoreContext';
import BaseModal from '../../base-modal/BaseModal';
import { View } from 'react-native';
import { Illustration } from '../../../illustration/Illustration';
import { ILLUSTRATION_NAMES } from '../../../illustration/illustration.helper';
import { TestIDs } from 'src/constants/testIDs.constants';
import { DynamicModalProps } from '../DynamicModal.types';
import { useRoute } from '@react-navigation/native';
import { ROUTE_NAMES } from 'src/routes/_shared/routes.constants';
import { useAddToCartHandlers } from 'src/hooks/useAddToCartHandlers';
import amplitude from 'src/_shared/amplitude';
import { AnalyticsEvents } from 'src/_shared/analyticsEvents';
import { useEffect } from 'react';
import { parseAnalyticsParamsByProduct } from 'src/_shared/analytics.utils';

export const ModalErrorCart = ({ type, dynamicModalVisible, dynamicModalLayer: { id } }: DynamicModalProps) => {
  const {
    i18n,
    dynamicModal: { closeModal },
    project: { activeProduct },
  } = useStore();
  const route = useRoute();
  const newRoute = [ROUTE_NAMES.EditorNew].includes(route?.name as ROUTE_NAMES);
  const { handleClickAddToCart } = useAddToCartHandlers(newRoute);

  const handleClose = () => {
    amplitude.trackEvent(AnalyticsEvents.personalize.uploadPhotoErrorClick, {
      ...parseAnalyticsParamsByProduct(activeProduct),
      action: 'close',
    });
    closeModal();
  };

  const handleConfirm = () => {
    amplitude.trackEvent(AnalyticsEvents.personalize.uploadPhotoErrorClick, {
      ...parseAnalyticsParamsByProduct(activeProduct),
      action: 'retry',
    });
    handleClickAddToCart();
  };

  useEffect(() => {
    amplitude.trackEvent(
      AnalyticsEvents.personalize.uploadPhotoErrorView,
      parseAnalyticsParamsByProduct(activeProduct),
    );
  }, []);

  return (
    <BaseModal
      testID={TestIDs.ERROR_CART}
      modalIcon={
        <View style={{ width: 100, height: 100 }}>
          <Illustration name={ILLUSTRATION_NAMES.UploadFailed} />
        </View>
      }
      title={i18n.t('modal-error-cart:title')}
      description={i18n.t('modal-error-cart:description')}
      confirmText={i18n.t('modal-error-cart:retry')}
      handleConfirm={handleConfirm}
      onClose={handleClose}
      onCloseOutside={handleClose}
      isVisible={dynamicModalVisible}
      type={type}
      id={id}
    />
  );
};
